module.exports = __webpack_public_path__ + "img/home-case-05.99dca880.png";